<template>
  <LangRouterLink
    :to="{ name: $route.name, query: filter.id === 0 ? null : { c: filter.slug }, hash: '#f' }"
    :class="[
      'activity__filter',
      filter.id !== 0 ? color(filter.color) : '',
      {
        '--active': isActive(filter),
        '--left':
          filter.index === max ||
          filter.index > lastActive ||
          (filter.index === lastActive && active < lastActive),
        '--right':
          filter.index === 0 ||
          filter.index < lastActive ||
          (filter.index === lastActive && active > lastActive),
      },
    ]"
    @click="updateCurrentFilter"
    :title="label"
  >
    {{ label }}
  </LangRouterLink>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import { color } from '@/helpers/color.js'

export default {
  name: 'ActivityFilter',
  props: {
    active: {
      type: Number,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    lastActive: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  components: { LangRouterLink },
  computed: {
    label() {
      return this.filter.id === 0 ? this.$t('activities.all') : this.filter.title
    },
  },
  methods: {
    color,
    isActive(filter) {
      if (filter.id === 0) {
        return !Object.values(this.$route.query).length
      }
      return filter.slug === this.$route.query.c
    },
    updateCurrentFilter() {
      this.$emit('updateActiveFilter', this.filter.index)
    },
  },
  emits: ['updateActiveFilter'],
}
</script>
